import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const PrimaryPhoneEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const contactInfo = useAppSelector(state => state.registration.currentRegistration?.contactInfo) || {};
  const value = contactInfo.phone || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      contactInfo: {
        ...contactInfo,
        phone: e.target.value,
      },
    }));
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      size="small"
      label="Primary Phone"
    />
  );
};

export default PrimaryPhoneEdit;
